import { Popover, Table, DatePicker } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import NotesAdd from "../../../assets/images/note-add.svg";

const CartTableSection = ({
  cart,
  posConfig,
  themeJSON,
  pricePrecision,
  cartItems,
  cartColumns,
  hasExpandableRows,
  selectedProductInCart,
  calendarVisible,
  setCalendarVisible,
  selectedDate,
  handleDateSelect,
  setNotesPopup,
  setNotesValue,
  setIsInputFocused,
  setShowInputFields,
  setRealPrice,
  setFirstInputValue,
  setSelectedCustomMix,
  setCustomMixItems,
  setGroupQty,
  setExistingGroupItems,
  setOverPayedAmount,
  setAmount,
  selectProductInCart,
  setQtyNumberFlag,
  setShowPaymentMethods,
  setSelectedProductInCart,
  setStockList,
  qtyInputRef,
}) => {
  const renderDeliveryDate = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          padding: "3px 6px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          color: "white",
          cursor: "pointer",
          width: "fit-content",
        }}
      >
        <CalendarOutlined style={{ fontSize: "0.85rem", cursor: "pointer", paddingBottom: "0.1em" }} />
        <span style={{ fontSize: "0.7rem" }}>{cart?.deliveryDate || "Delivery Date"}</span>
      </div>
    );
  };

  const calendarContent = (record) => {
    // With showTime, antd fires onChange on date pick, time pick, and on "Ok".
    // But when the picker is rendered inside a Popover, the DatePicker's internal
    // dropdown can swallow the Ok click — onChange never fires. Wire onOk (which
    // fires reliably when the user clicks "Ok") to the same handler so the
    // Popover closes either way.
    const handler = handleDateSelect(record);
    return (
      <DatePicker
        showTime={{ format: "hh:mm A" }}
        format="DD-MM-YYYY hh:mm A"
        onChange={handler}
        onOk={(date) => handler(date, date ? date.format("DD-MM-YYYY hh:mm A") : "")}
        disabledDate={(current) => current && current < dayjs().startOf("day")}
        value={selectedDate}
        style={{ width: 250 }}
      />
    );
  };

  return (
    <div style={{ padding: "1.5%", display: "flex", gap: "1rem", width: "100%" }}>
      <div style={{ width: "100%" }}>
      {cart.layAway === "Y" && posConfig?.advanceLayaway === "Y" ? (
        <div style={{ position: "absolute", bottom: "29vh", left: "56vw", display: "flex", alignItems: "center", gap: "12px" }}>
          <span style={{ opacity: "0.5" }}>ADVANCE</span>
        </div>
      ) : null}
      <div
        style={{
          position: "absolute",
          top: "57%",
          left: "30%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "54px",
          zIndex: 10,
        }}
      >
        <span style={{ fontFamily: "Montserrat", fontWeight: "bold", fontSize: "50px", color: "#000", textAlign: "center", opacity: "10%" }}>PRE-ORDER</span>
      </div>
      {/* Cart table header */}
      <div
        style={{
          height: "6vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          textAlign: "center",
          backgroundColor: "#7A92AC",
          padding: "1vw 0.5rem",
          borderTopLeftRadius: "5px",
          borderTopRightRadius: "5px",
          color: "#fff",
        }}
      >
        <span style={{ fontSize: "0.85rem", cursor: "pointer" }}>Pre-Order</span>
        <span style={{ fontSize: "0.7rem", display: "flex", alignItems: "center", justifyContent: "center" }}>
          {posConfig?.disableOfflineBilling !== "Y" && <>Pre-Order No: {cart.documentno}</>}
          {posConfig?.enableOrderLevelNarration === "Y" && (
          <img
            src={NotesAdd}
            onClick={() => {
              setNotesPopup(true);
              if (cart.description && cart.description.trim() !== "") setNotesValue(cart.description);
              setIsInputFocused(true);
            }}
            style={{ height: "0.85rem", paddingLeft: "0.7rem", cursor: "pointer", paddingRight: "0.3rem" }}
          />
          )}
          {posConfig?.enableDeliveryDate === "Y" && (
            <Popover content={calendarContent(null)} trigger="click" open={calendarVisible} onVisibleChange={(visible) => setCalendarVisible(visible)}>
              {renderDeliveryDate()}
            </Popover>
          )}
        </span>
      </div>
      {/* Cart table */}
      <Table
        className="sm-cart-table-pos"
        style={{ width: "100%", overflowY: "auto", border: "none", borderRadius: "7px", padding: "0px 7px", height: "50.5vh", background: themeJSON.productTableBGColor || "#fff", fontSize: "0.78rem", overflowX: "hidden" }}
        pagination={false}
        dataSource={cartItems}
        sticky
        id="sm-cart-table"
        rowKey="lineId"
        rowClassName={(record) => (selectedProductInCart.lineId === record.lineId ? "tableRowSelectedBlue" : "tableRowNonSelectedWhite")}
        columns={cartColumns}
        {...(hasExpandableRows && {
          expandable: {
            expandedRowRender: (record) => (record.children && record.children.length > 0 ? <div></div> : null),
            rowExpandable: (record) => record.children && record.children.length > 0,
          },
        })}
        onRow={(record) => ({
          onClick: () => {
            qtyInputRef?.current?.focus();
            if (record.posPriceEdit === "Y") {
              qtyInputRef?.current?.focus();
              setShowInputFields(true);
              setRealPrice(record.weight);
              setFirstInputValue(true);
            } else {
              setShowInputFields(false);
            }
            if (record.children && record.children.length > 0) {
              // See SMCartTable for context — children carry scaled weights;
              // restore per-unit before handing to the CustomMix modal so
              // submit doesn't re-multiply by groupQty. (Tab8 issues #8/#9)
              const groupQtyVal = Number(record.weight) || 1;
              const baseChildren = record.children.map((c) => {
                const base = c.baseQty != null ? Number(c.baseQty) : groupQtyVal > 0 ? Number(c.weight) / groupQtyVal : Number(c.weight);
                return { ...c, weight: base, rawWeight: String(base) };
              });
              setSelectedCustomMix(record);
              setCustomMixItems(baseChildren);
              setGroupQty(record.weight);
              setExistingGroupItems(true);
            }
            setIsInputFocused(false);
            setOverPayedAmount(0);
            setAmount(parseFloat((cart.total - cart.paid).toFixed(pricePrecision)));
            selectProductInCart(record);
            setQtyNumberFlag(0);
            setShowPaymentMethods(false);
            setSelectedProductInCart(record);
            setStockList([]);
          },
        })}
      />
      </div>
    </div>
  );
};

export default CartTableSection;
